// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V0bF","buttons":"styles_buttons__3w9KU"};